// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kE-z","hovered":"lE-z","hoverImage":"mE-z","mainImage":"nE-z","imageNoBackground":"oE-z","fullSizeImage":"pE-z"};